import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const Eye: FC<IconProps> = ({ width = "20", height = "14", color = "none", onClick, className }) => {
	return (
		<Svg width={width} height={height} viewBox="0 0 20 14" fill={color} onClick={onClick} className={className}>
			<path
				d="M17.9534 6.20423C18.2067 6.5595 18.3334 6.73714 18.3334 7.00008C18.3334 7.26303 18.2067 7.44066 17.9534 7.79593C16.815 9.39221 13.9078 12.8334 10.0001 12.8334C6.0924 12.8334 3.18516 9.39221 2.04678 7.79593C1.79343 7.44066 1.66675 7.26303 1.66675 7.00008C1.66675 6.73714 1.79343 6.5595 2.04678 6.20424C3.18516 4.60795 6.0924 1.16675 10.0001 1.16675C13.9078 1.16675 16.815 4.60795 17.9534 6.20423Z"
				stroke="#344054"
				strokeWidth="1.66667"
			/>
			<path
				d="M12.5001 7.00008C12.5001 5.61937 11.3808 4.50008 10.0001 4.50008C8.61937 4.50008 7.50008 5.61937 7.50008 7.00008C7.50008 8.38079 8.61937 9.50008 10.0001 9.50008C11.3808 9.50008 12.5001 8.38079 12.5001 7.00008Z"
				stroke="#344054"
				strokeWidth="1.66667"
			/>
		</Svg>
	);
};
